import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { getMessengers } from "apis/messangers";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { user, workspace } from "recoil/recoilState";
const SlackConnectWarning = ({ isLinkedSlack = true }: { isLinkedSlack?: boolean }) => {
  const workspaceInfo = useRecoilValue(workspace);
  const [isSlackConnected, setIsSlackConnected] = useState<boolean>();
  const navigator = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getMessengers().then((res) => {
      const connected = res.data?.find((item) => item.messengerProvider === "SLACK");
      if (connected) setIsSlackConnected(true);
      else setIsSlackConnected(false);
    });
  }, [isLinkedSlack]);

  const isShow = () => {
    if (
      workspaceInfo?.mileVisitorsUsage &&
      isSlackConnected === false &&
      (location.pathname.includes("visitors") || location.pathname.includes("setting"))
    )
      return "flex";
    else return "none";
  };

  return (
    <Container
      style={{
        display: isShow(),
      }}
    >
      <div className="content">
        <UI.Icon name="inform" size={20} color="var(--alias-color-label-alternative)" />
        <UI.Typography type="body02 normal" fontStyle="regular" color="var(--alias-color-label-neutral)">
          해당 계정은{" "}
          <strong
            style={{
              fontWeight: 700,
            }}
          >
            슬랙 메신저 미연동 상태
          </strong>
          입니다. 원활한 Mile Visitors 사용을 위해{" "}
          <strong
            style={{
              fontWeight: 700,
            }}
          >
            슬랙 메신저를 연동
          </strong>
          해주세요.
        </UI.Typography>
      </div>
      <UI.ButtonGroups.Text
        title="연동하기"
        size="small"
        onClick={() => {
          navigator("/setting/서비스 연동 관리");
        }}
      />
    </Container>
  );
};

export default SlackConnectWarning;

const Container = styled.div`
  display: flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  border-top: 1px solid var(--alias-color-line-normal);
  border-bottom: 1px solid var(--alias-color-line-normal);
  background: var(--global-color-red-95);

  .content {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
